import ImageGallery from "../src/components/organisms/image-gallery/image-gallery.utils";
import ListingNavigation from "../src/components/molecules/listings-navigation/listings-navigation.utils";
import MapsBlock from "../src/components/organisms/maps-block/maps-block.utils";
import NavigationBar from "../src/components/organisms/navigation-bar/navigation-bar.utils";
import RichTextComponent from "./components/organisms/rich-text-block/rich-text-block";
import SearchModal from "../src/components/organisms/search-modal/search-modal.utils";
import Alert from "./components/organisms/alert/alert.utils";
import Graph from "./components/organisms/graphs/graphs.utls";
import Hero from "./components/organisms/hero/hero.utils";
import EmbedBlock from "./components/organisms/embed-block/embed-block.utils";
import './main.scss';
window.addEventListener("load", (event) => {
    ImageGallery.init();
    ListingNavigation.init();
    MapsBlock.init();
    NavigationBar.init();
    RichTextComponent.init();
    SearchModal.init();
    Alert.init();
    Graph.init();
    Hero.init();
    EmbedBlock.init();
});
